import { combine, withCallback } from 'react-hooks-combine'

import { withRouter } from 'react-router'
import { event } from 'routes/route.map'
import NameRedirectComponent from './component'

export default combine({
  hocs: [withRouter],
  hooks: [
    withCallback(
      'handleClickName',
      (_, { history }) =>
        (tournamentId) => {
          history.push(
            `${event()}#tournament=${encodeURIComponent(tournamentId)}`
          )
        },
      []
    ),
  ],
})(NameRedirectComponent)
